import { getAppDomainName } from '../../../../../../features/helpers/getAppDomainName'

export const getPlatformUtmCode = () => {
  const appName = getAppDomainName()
  // app name without spaces
  return appName.replace(/\s/g, '')
}
